import { SerialPortIcon } from './SerialPortIcon';

/**
 * author: Simran
 * id 5D18BB49-3214-49C0-BD5C-B4581172C650
 * name serial-port
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/serial-port.svg
 * tags
 */
export const VgaIcon = SerialPortIcon;
export default VgaIcon